module.exports = __webpack_public_path__ + "static/media/documentation.265a9c5a.md";